import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'formatMailboxMessageCount',
   standalone: false
})
export class FormatMailboxMessageCountPipe implements PipeTransform {
   transform(count: number): string {
      return formatMailboxMessageCount(count);
   }
}

export function formatMailboxMessageCount(count: number): string {
   if (count < 1000) {
      return String(count);
   }

   return `${Math.min(Math.floor(count / 1000), 5)}K+`;
}